let enabledElements = [];

export function hasEnabledElement(element) {
  if (element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      return true;
    }
  }
  return false;
}

/**
 * Retrieves a  Enabled Element object
 *
 * @param {HTMLElement} element An HTML Element enabled for
 *
 * @returns {EnabledElement} A  Enabled Element
 * @memberof EnabledElements
 */
export function getEnabledElement(element) {
  if (element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      return enabledElements[i];
    }
  }

  throw new Error("element not enabled");
}

export function updateEnabledElement(elementStub) {
  if (elementStub.element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === elementStub.element) {
      enabledElements[i] = elementStub;
    }
  }
}

export function setEnabledElement(element, elementStub) {
  if (element === undefined) {
    throw new Error(
      "getEnabledElement: parameter element must not be undefined"
    );
  }
  for (let i = 0; i < enabledElements.length; i++) {
    if (enabledElements[i].element === element) {
      enabledElements[i] = elementStub;
    }
  }

  throw new Error("element not enabled");
}

/**
 * Adds a  Enabled Element object to the central store of enabledElements
 *
 * @param {EnabledElement} enabledElement A  enabledElement Object
 * @returns {void}
 * @memberof EnabledElements
 */
export function addEnabledElement(enabledElement) {
  if (enabledElement === undefined) {
    throw new Error(
      "getEnabledElement: enabledElement element must not be undefined"
    );
  }

  enabledElements.push(enabledElement);
}

/**
 * Adds a  Enabled Element object to the central store of enabledElements
 *
 * @param {string} imageId A  Image ID
 * @returns {EnabledElement[]} An Array of  enabledElement Objects
 * @memberof EnabledElements
 */
export function getEnabledElementsByImageId(imageId) {
  const ees = [];

  enabledElements.forEach(function(enabledElement) {
    if (enabledElement.image && enabledElement.image.imageId === imageId) {
      ees.push(enabledElement);
    }
  });

  return ees;
}

/**
 * Retrieve all of the currently enabled  elements
 *
 * @return {EnabledElement[]} An Array of  enabledElement Objects
 * @memberof EnabledElements
 */
export function getEnabledElements() {
  return enabledElements;
}

/**
 * Clear all of the currently enabled elements
 *
 * @memberof EnabledElements
 */
export function clearAllImage() {
  for (let i = 0; i < enabledElements.length; i++) {
    enabledElements[i].image = null;
  }
  //enabledElements.
  //enabledElements = [];
}
